// extracted by mini-css-extract-plugin
export default {"container":"NotificationsPage_container__LF+7L","content":"NotificationsPage_content__KjItm"};